// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"f5ba514c","339":"5c60bfa6","423":"ed088183","626":"2ffd6bbb","628":"115b2e15","732":"7e58b3a3","767":"3654c535","835":"ca629d4f","911":"24648b24"}[chunkId] + ".chunk.js";
};